import type { ReactNode } from 'react';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { getClientData } from '../utils/helper';
import { mfaTokenPrefix } from '../constants';
import { Config } from '../services/Config';

export const IdContext = React.createContext<any>({});

export const IdContextProvider = ({ children }: { children: ReactNode }) => {
  const router = useRouter();
  const [clientData, setClientData] = useState({
    redirectURL: '',
    clientState: '',
    useCookieStorage: Config.APPLICATION_AUTH_USE_COOKIE_STORAGE, //default to true
  });

  const [sessionMfaKey, setSessionMfaKey] = useState(
    `${mfaTokenPrefix}.${Config.APPLICATION_AUTH_OAUTH_DEFAULTCLIENTID}.token`
  );

  useEffect(() => {
    // @todo check if we need this
    // const checkValidReq = (pathname: string) => {
    //   if (
    //     Config.APPLICATION_AUTH_BACKENDSTAGE !== 'dev' &&
    //     ((router.asPath.includes('client_id') && router?.query?.client_id) ||
    //       !router.asPath.includes('client_id')) &&
    //     ![
    //       '/',
    //       '/login',
    //       '/forgot-password',
    //       '/reset-password',
    //       '/signout',
    //       '/signup',
    //       '/mfa',
    //       '/verifycode',
    //       '/mfa-recovery',
    //     ].includes(pathname)
    //   ) {
    //     throw new Error('Bad request');
    //   }
    // };

    if (!clientData?.redirectURL) {
      //TODO fix ? issue
      const [wRedirect, wState] = getClientData(router) as any[];
      if (wRedirect) {
        setClientData({
          redirectURL: wRedirect || '',
          clientState: wState || '',
          useCookieStorage: Config.APPLICATION_AUTH_USE_COOKIE_STORAGE,
        });
      }
    } else {
      // checkValidReq(router.pathname);
    }
  }, [router, clientData, sessionMfaKey]);
  return (
    <IdContext.Provider
      value={{ ...clientData, sessionMfaKey, setSessionMfaKey }}
    >
      {children}
    </IdContext.Provider>
  );
};
